/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicReferralProgramModule
 */
export interface PublicReferralProgramModule {
    /**
     * 
     * @type {boolean}
     * @memberof PublicReferralProgramModule
     */
    enabled?: boolean;
    /**
     * Referral credit dollar amount, surfaced so patient-facing referral copy can show the real value.
     * @type {number}
     * @memberof PublicReferralProgramModule
     */
    credit_amount?: number;
}

/**
 * Check if a given object implements the PublicReferralProgramModule interface.
 */
export function instanceOfPublicReferralProgramModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PublicReferralProgramModuleFromJSON(json: any): PublicReferralProgramModule {
    return PublicReferralProgramModuleFromJSONTyped(json, false);
}

export function PublicReferralProgramModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicReferralProgramModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'credit_amount': !exists(json, 'credit_amount') ? undefined : json['credit_amount'],
    };
}

export function PublicReferralProgramModuleToJSON(value?: PublicReferralProgramModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'credit_amount': value.credit_amount,
    };
}

